import { UseLoadingReturn } from "@/hooks/use-loading";
import campaignItemService from "@/services/campaign-item.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type UseRemoveCampaignItemReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCampaignItem = (): UseRemoveCampaignItemReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (itemId) => campaignItemService.delete(itemId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveCampaignItem;
